var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "field fileInput",
      class: [
        {
          "has-error": _vm.v && _vm.v.$anyError,
          "is-required": _vm.isRequired,
        },
        _vm.classes,
      ],
      attrs: { disabled: _vm.iniDisabled },
    },
    [
      _vm.label
        ? _c("label", { staticClass: "label" }, [_vm._v(_vm._s(_vm.label))])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "control is-expanded" },
        [
          !_vm.iniDisabled
            ? [
                _c(
                  "div",
                  { staticClass: "section blank" },
                  [
                    _vm.isUploading
                      ? _c(
                          "div",
                          { staticClass: "has-text-centered" },
                          [
                            _c("loader", {
                              attrs: { text: _vm.$t("uploadingDocuments") },
                            }),
                            _vm._v(" "),
                            _c("b-progress", {
                              attrs: {
                                size: "is-small is-success",
                                value: _vm.progress,
                              },
                            }),
                          ],
                          1
                        )
                      : [
                          _vm.showSelectButton
                            ? [
                                _c(
                                  "b-upload",
                                  {
                                    attrs: {
                                      accept: _vm.typeLimit.join(","),
                                      multiple: _vm.isMultiple,
                                      "drag-drop": _vm.isDragDrop,
                                    },
                                    on: { input: _vm.onUploadFilesChoosen },
                                    model: {
                                      value: _vm.uploadModel,
                                      callback: function ($$v) {
                                        _vm.uploadModel = $$v
                                      },
                                      expression: "uploadModel",
                                    },
                                  },
                                  [
                                    _vm.isDragDrop
                                      ? [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "content has-text-centered",
                                            },
                                            [
                                              _c("font-awesome-icon", {
                                                attrs: {
                                                  icon: [
                                                    "fas",
                                                    "cloud-upload-alt",
                                                  ],
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("p", [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "drop-your-files-here-or-click-to-upload"
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                ),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ]
                                      : [
                                          _c(
                                            "div",
                                            {
                                              class: {
                                                "text-center":
                                                  _vm.enableExistingDocuments,
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "button is-cancel",
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    { staticClass: "icon" },
                                                    [
                                                      _c("font-awesome-icon", {
                                                        attrs: {
                                                          icon: [
                                                            "fas",
                                                            "cloud-upload-alt",
                                                          ],
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          _vm.isMultiple
                                                            ? "selectDocuments"
                                                            : "selectDocument"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ],
                                  ],
                                  2
                                ),
                              ]
                            : _vm._e(),
                        ],
                  ],
                  2
                ),
              ]
            : _vm.showNoValueDisabled
            ? [_c("textInput", { attrs: { iniDisabled: true } })]
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "thumbnail-list" },
            [
              _vm.selected
                ? [
                    _vm._l(
                      _vm.selected.files.slice(0, _vm.slicerCount),
                      function (file, index) {
                        return [
                          _c(
                            "thumbnail",
                            {
                              key: `file_${index}`,
                              class: {
                                "has-popover": _vm.usePopover,
                                "is-success": file.isAdded,
                              },
                              attrs: {
                                data: file,
                                renderType: _vm.renderType,
                                showPreview: _vm.showPreview,
                                showProperties: _vm.showProperties,
                                addClick: _vm.showCarousel,
                              },
                              on: { click: _vm.onThumbailClick },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "actions d-flex v-center h-center",
                                },
                                [
                                  (file.id || file.fileId) && !_vm.hideDetail
                                    ? _c(
                                        "button",
                                        {
                                          staticClass:
                                            "button is-detailMenu on-hover",
                                          on: {
                                            click: function ($event) {
                                              $event.preventDefault()
                                              return _vm.onDetailClick(file)
                                            },
                                          },
                                        },
                                        [
                                          _c("font-awesome-icon", {
                                            attrs: { icon: ["fas", "eye"] },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  !_vm.iniDisabled
                                    ? [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "button is-danger is-small on-hover",
                                            on: {
                                              click: function ($event) {
                                                return _vm.doDelete(index)
                                              },
                                            },
                                          },
                                          [
                                            _c("font-awesome-icon", {
                                              attrs: {
                                                icon: ["fas", "trash-alt"],
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ]
                          ),
                        ]
                      }
                    ),
                    _vm._v(" "),
                    _vm.usePopover
                      ? _c(
                          "a",
                          {
                            staticClass: "ml5-xs",
                            attrs: { href: "" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                _vm.showCarouselModal = true
                              },
                            },
                          },
                          [
                            _c("b-tag", { attrs: { type: "is-success" } }, [
                              _vm._v(
                                "+ " + _vm._s(_vm.selected.files.length - 1)
                              ),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.uploads &&
              _vm.uploads.length > 0 &&
              !_vm.iniDisabled &&
              !_vm.isUploading
                ? [
                    _vm._l(_vm.uploads, function (file, index) {
                      return [
                        _c(
                          "thumbnail",
                          {
                            key: `upload_${index}`,
                            class: [
                              "is-success",
                              {
                                "is-danger": file.toobig,
                              },
                            ],
                            attrs: {
                              data: file,
                              renderType: _vm.renderType,
                              showPreview: _vm.showPreview,
                              showProperties: _vm.showProperties,
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "actions" },
                              [
                                !_vm.iniDisabled
                                  ? [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "is-danger button is-small",
                                          attrs: { type: "button" },
                                          on: {
                                            click: function ($event) {
                                              $event.preventDefault()
                                              return _vm.doDeleteUpload(index)
                                            },
                                          },
                                        },
                                        [
                                          _c("font-awesome-icon", {
                                            attrs: {
                                              icon: ["fas", "trash-alt"],
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  : [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "button is-close is-static",
                                        },
                                        [
                                          _c("font-awesome-icon", {
                                            attrs: {
                                              icon: ["fas", "cloud-upload-alt"],
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                              ],
                              2
                            ),
                            _vm._v(" "),
                            file.toobig
                              ? [
                                  _c("div", { staticClass: "flex-break" }),
                                  _vm._v(" "),
                                  _c(
                                    "b-tag",
                                    {
                                      staticClass: "mx10-xs",
                                      attrs: { type: "is-danger" },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm.$t("notAllowedSize", {
                                              size: (
                                                file.size * 0.000001
                                              ).toFixed(1),
                                            })
                                          )
                                      ),
                                    ]
                                  ),
                                ]
                              : _vm._e(),
                          ],
                          2
                        ),
                      ]
                    }),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ],
        2
      ),
      _vm._v(" "),
      _vm.v && _vm.v.$anyError
        ? _c("span", { staticClass: "help is-danger" }, [_vm._t("onError")], 2)
        : _vm._e(),
      _vm._v(" "),
      !!this.$slots.help
        ? _c("span", { staticClass: "help info" }, [_vm._t("help")], 2)
        : _vm._e(),
      _vm._v(" "),
      _vm.selected && _vm.selected.files && _vm.showCarousel
        ? [
            _c("modal", {
              attrs: { value: _vm.showCarouselModal, showFooter: false },
              scopedSlots: _vm._u(
                [
                  {
                    key: "content",
                    fn: function () {
                      return [
                        _c(
                          "b-carousel",
                          {
                            attrs: {
                              "indicator-inside": false,
                              indicator: _vm.selected.files.length > 1,
                              arrow: _vm.selected.files.length > 1,
                            },
                          },
                          _vm._l(_vm.selected.files, function (item, i) {
                            return _c("b-carousel-item", { key: i }, [
                              _c("span", { staticClass: "image" }, [
                                _c("img", { attrs: { src: item.src } }),
                              ]),
                            ])
                          }),
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "text-center mt15-xs" }, [
                          _c(
                            "button",
                            {
                              staticClass: "button is-cancel",
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  _vm.showCarouselModal = false
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.$t("close")) +
                                  "\n                    "
                              ),
                            ]
                          ),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                ],
                null,
                false,
                1100139904
              ),
            }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }